import { render } from "./FormGroup.vue?vue&type=template&id=04a2a8f4&scoped=true"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"

import "./FormGroup.vue?vue&type=style&index=0&id=04a2a8f4&scoped=true&lang=css"
import "./FormGroup.vue?vue&type=style&index=1&id=04a2a8f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a2a8f4"]])

export default __exports__